module.exports = __webpack_public_path__ + "img/logo.6e8f916d.svg";